var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "new-grouping" },
    [
      _c(
        "b-modal",
        {
          ref: "mapGroupRef",
          staticClass: "modal-info",
          attrs: { title: "Add Grouping", centered: "" },
          on: { hide: _vm.cancelNewGrouping, shown: _vm.focusOnInput }
        },
        [
          _c(
            "b-container",
            { attrs: { fluid: "" } },
            [
              _c(
                "b-row",
                { staticClass: "mb-3" },
                [
                  _c("b-col", { attrs: { cols: "3" } }, [
                    _vm._v("Name"),
                    _c("i", { staticClass: "required" }, [_vm._v("*")])
                  ]),
                  _vm._v(" "),
                  _c(
                    "b-col",
                    [
                      _c("b-form-input", {
                        ref: "groupName",
                        attrs: {
                          type: "text",
                          placeholder: "Group Name",
                          required: ""
                        },
                        model: {
                          value: _vm.group.name,
                          callback: function($$v) {
                            _vm.$set(_vm.group, "name", $$v)
                          },
                          expression: "group.name"
                        }
                      }),
                      _vm._v(" "),
                      _vm.group.name && !_vm.group.isNameUnique
                        ? _c("div", { staticStyle: { color: "red" } }, [
                            _vm._v("Name must be unique.")
                          ])
                        : _vm._e()
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "b-row",
                { staticClass: "mb-3" },
                [
                  _c("b-col", { attrs: { cols: "3" } }, [
                    _vm._v("Type"),
                    _c("i", { staticClass: "required" }, [_vm._v("*")])
                  ]),
                  _vm._v(" "),
                  _c(
                    "b-col",
                    [
                      _c("b-form-select", {
                        attrs: {
                          plain: true,
                          options: _vm.groupTypes,
                          placeholder: "Group Type"
                        },
                        on: {
                          input: function($event) {
                            _vm.handleRequired()
                          }
                        },
                        model: {
                          value: _vm.group.type,
                          callback: function($$v) {
                            _vm.$set(_vm.group, "type", $$v)
                          },
                          expression: "group.type"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "b-row",
                { staticClass: "mb-3" },
                [
                  _c(
                    "b-col",
                    { staticClass: "modal-label", attrs: { cols: "3" } },
                    [_vm._v(_vm._s(_vm.$t("TEMPLATE.ORDER_OF_OCCUR")))]
                  ),
                  _vm._v(" "),
                  _c(
                    "b-col",
                    [
                      _c("b-form-select", {
                        attrs: {
                          plain: true,
                          options: _vm.orderOptions,
                          placeholder: "Group Order"
                        },
                        model: {
                          value: _vm.group.order,
                          callback: function($$v) {
                            _vm.$set(_vm.group, "order", $$v)
                          },
                          expression: "group.order"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _vm.canShowRequired
                ? _c(
                    "b-row",
                    { staticClass: "mb-3" },
                    [
                      _c("b-col", { attrs: { cols: "3" } }, [
                        _vm._v(_vm._s(_vm.$t("TEMPLATE.REQ")))
                      ]),
                      _vm._v(" "),
                      _c(
                        "b-col",
                        [
                          _c("b-form-radio-group", [
                            _c(
                              "div",
                              {
                                staticClass:
                                  "custom-control custom-radio custom-control-inline"
                              },
                              [
                                _c("input", {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value: _vm.group.required,
                                      expression: "group.required"
                                    }
                                  ],
                                  staticClass: "custom-control-input",
                                  attrs: {
                                    type: "radio",
                                    id: "requiredGrpNewYes"
                                  },
                                  domProps: {
                                    value: true,
                                    checked: _vm._q(_vm.group.required, true)
                                  },
                                  on: {
                                    change: function($event) {
                                      _vm.$set(_vm.group, "required", true)
                                    }
                                  }
                                }),
                                _vm._v(" "),
                                _c(
                                  "label",
                                  {
                                    staticClass: "custom-control-label",
                                    attrs: { for: "requiredGrpNewYes" }
                                  },
                                  [_vm._v(_vm._s(_vm.$t("COMMON.YES")))]
                                )
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                staticClass:
                                  "custom-control custom-radio custom-control-inline"
                              },
                              [
                                _c("input", {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value: _vm.group.required,
                                      expression: "group.required"
                                    }
                                  ],
                                  staticClass: "custom-control-input",
                                  attrs: {
                                    type: "radio",
                                    id: "requiredGrpNewNo"
                                  },
                                  domProps: {
                                    value: false,
                                    checked: _vm._q(_vm.group.required, false)
                                  },
                                  on: {
                                    change: function($event) {
                                      _vm.$set(_vm.group, "required", false)
                                    }
                                  }
                                }),
                                _vm._v(" "),
                                _c(
                                  "label",
                                  {
                                    staticClass: "custom-control-label",
                                    attrs: { for: "requiredGrpNewNo" }
                                  },
                                  [_vm._v(_vm._s(_vm.$t("COMMON.NO")))]
                                )
                              ]
                            )
                          ])
                        ],
                        1
                      )
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.selectedChildren.length > 1
                ? _c(
                    "b-row",
                    { staticClass: "mb-3" },
                    [
                      _c("b-col", { attrs: { cols: "12" } }, [
                        _c("h6", { staticClass: "pull-left select-mappings" }, [
                          _vm._v("Select the mappings to include in the group:")
                        ])
                      ]),
                      _vm._v(" "),
                      _vm._l(_vm.groupChildren, function(child) {
                        return _c(
                          "b-col",
                          { key: child.attrs.path, attrs: { cols: "6" } },
                          [
                            _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.selectedChildren,
                                  expression: "selectedChildren"
                                }
                              ],
                              staticClass: "pull-left mt-1 mr-2",
                              attrs: {
                                type: "checkbox",
                                id: child.attrs.uniq_id
                              },
                              domProps: {
                                value: child.attrs.uniq_id,
                                checked: Array.isArray(_vm.selectedChildren)
                                  ? _vm._i(
                                      _vm.selectedChildren,
                                      child.attrs.uniq_id
                                    ) > -1
                                  : _vm.selectedChildren
                              },
                              on: {
                                change: function($event) {
                                  var $$a = _vm.selectedChildren,
                                    $$el = $event.target,
                                    $$c = $$el.checked ? true : false
                                  if (Array.isArray($$a)) {
                                    var $$v = child.attrs.uniq_id,
                                      $$i = _vm._i($$a, $$v)
                                    if ($$el.checked) {
                                      $$i < 0 &&
                                        (_vm.selectedChildren = $$a.concat([
                                          $$v
                                        ]))
                                    } else {
                                      $$i > -1 &&
                                        (_vm.selectedChildren = $$a
                                          .slice(0, $$i)
                                          .concat($$a.slice($$i + 1)))
                                    }
                                  } else {
                                    _vm.selectedChildren = $$c
                                  }
                                }
                              }
                            }),
                            _vm._v(" "),
                            _c(
                              "label",
                              {
                                staticClass: "pull-left",
                                attrs: { for: child.attrs.uniq_id }
                              },
                              [
                                _vm._v(
                                  "\n            " +
                                    _vm._s(child.attrs.key) +
                                    " " +
                                    _vm._s(
                                      child.attrs.map_type === "shape"
                                        ? null
                                        : "( " + child.attrs.map_type + " )"
                                    ) +
                                    "\n          "
                                )
                              ]
                            )
                          ]
                        )
                      })
                    ],
                    2
                  )
                : _vm._e()
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "w-100 d-flex justify-content-end",
              attrs: { slot: "modal-footer" },
              slot: "modal-footer"
            },
            [
              _c(
                "b-btn",
                {
                  staticClass: "float-right",
                  attrs: {
                    size: "sm",
                    variant: "primary mr-1",
                    disabled: !_vm.validateGroupInfo
                  },
                  on: { click: _vm.createNewGrouping }
                },
                [_vm._v("Add")]
              ),
              _vm._v(" "),
              _c(
                "b-btn",
                {
                  staticClass: "float-right",
                  attrs: { size: "sm", variant: "light" },
                  on: { click: _vm.cancelGrouping }
                },
                [_vm._v("Cancel")]
              )
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "b-modal",
        {
          ref: "agnetNewGroupingModal",
          attrs: {
            title: "New-Grouping",
            "hide-header-close": "",
            centered: "",
            "ok-only": "",
            "ok-variant": "secondary"
          },
          on: { ok: _vm.clearGrouping }
        },
        [
          _c("p", [
            _vm._v(
              "You are not permitted to access this. Kindly contact administrator"
            )
          ])
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-2b0948c3", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2b0948c3","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/templates/newGrouping.vue
// module id = 1119
// module chunks = 2